import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ButtonText } from '@morressier/alembic';

type IProps = {
  editCallback?: () => void;
};

export const TagInputEmptyState: React.FC<IProps> = ({ editCallback }) => (
  <Flex flexDirection={'column'} gap={2}>
    <Text textStyle={'textBody'} />
    {editCallback && (
      <ButtonText onClick={editCallback} alignSelf={'flex-start'}>
        Update
      </ButtonText>
    )}
  </Flex>
);
